<template>

  <span>

    <Feature
      v-for="(feature, featureIndex) in features" 
      :key="featureIndex" 
      :type="feature.type"
      :active="feature.active"
    />

  </span>

</template>

<script>
import Feature from './FeatureIcon.vue'
export default {
  name: 'Features',
  props: ['settings'],
  components: {Feature},
  data() {
    return {
      info: this.settings
    }
  },
  computed: {

    features() {

      let features = [];

      Object.keys(this.settings.features).forEach( function ( f ) {

         features.push( { type: f, active: this.settings.features[f] } );

      }.bind(this));

      return features;

    }

  }
}
</script>